import { FC } from 'react';

export const DocumentFilled: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V9.82843C18 9.56321 17.8946 9.30886 17.7071 9.12132L12.8787 4.29289C12.6911 4.10536 12.4368 4 12.1716 4H7ZM4 5C4 3.34315 5.34315 2 7 2H12.1716C12.9672 2 13.7303 2.31607 14.2929 2.87868L19.1213 7.70711C19.6839 8.26972 20 9.03278 20 9.82843V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM8 9C8 8.44772 8.44772 8 9 8H11C11.5523 8 12 8.44772 12 9C12 9.55228 11.5523 10 11 10H9C8.44772 10 8 9.55228 8 9ZM8 13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z"
			fill="currentColor"
		/>
	</svg>
);
